import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { FormsData } from "../models/FormsData";
import { Forms } from "../models/Forms";
import { QuerySearch } from "../models/QuerySearch";
import { FormResponse } from "../models/FormResponse";

export class FormsService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/forms`;
  }

  async getFormModelById(id: string): Promise<Response<FormResponse | void>> {
    return (await axios.get(`${this.baseUrl}/model/${id}`)).data;
  }

  async userForms(id: string): Promise<Response<FormsData[]>> {
    return (await axios.get(`${this.baseUrl}/user/${id}`)).data;
  }

  async adduserForm(id: string, form: Forms): Promise<Response<string | void>> {
    return (await axios.post(`${this.baseUrl}/user/${id}`, form)).data;
  }

  async formInformation(query: QuerySearch): Promise<Response<FormsData>> {
    return (await axios.get(`${this.baseUrl}/data`, { params: query })).data;
  }

  async searchLastFormByUser(query: QuerySearch): Promise<Response<void>> {
    return (await axios.get(`${this.baseUrl}/by-user`, { params: query })).data;
  }

  async updateForm(
    id: string,
    taskId: string,
    form: Forms
  ): Promise<Response<string | void>> {
    return (await axios.put(`${this.baseUrl}/${id}/${taskId}`, form)).data;
  }

  async updateOneForm(
    id: string,
    form: Forms
  ): Promise<Response<string | void>> {
    return (await axios.put(`${this.baseUrl}/form/update/${id}`, form)).data;
  }

  async formServiceInformation(
    query: QuerySearch
  ): Promise<Response<FormsData>> {
    return (
      await axios.get(`${this.baseUrl}/service/sections`, {
        params: query
      })
    ).data;
  }

  async addServiceSectionsForm(
    form: Forms,
    serviceTemplateVersion?: number
  ): Promise<Response<string | void>> {
    return (
      await axios.post(`${this.baseUrl}/service/sections`, {
        form,
        serviceTemplateVersion
      })
    ).data;
  }

  async deleteServiceSectionsForm(
    formId: string
  ): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/service/sections/${formId}`))
      .data;
  }

  async addIntelliticksForm(
    forms: Forms,
    service: string
  ): Promise<Response<string | void>> {
    return (
      await axios.post(`${this.baseUrl}/intelliticks/`, {
        ...forms,
        service
      })
    ).data;
  }

  async deleteFormByArray(formsIdFilled: string[]): Promise<Response<string>> {
    return (
      await axios.delete(`${this.baseUrl}/by-array/`, {
        data: { formsIdFilled }
      })
    ).data;
  }
}
